import {BasicEntity} from '../../framework/message/BasicEntity';

export class Language extends BasicEntity {
alphabet: string;
code: string;
icon: string;
label: string;
}

